import { useMemo } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { IHeaderMenuItem } from './types'

export function useHeaderMenuItems(shouldShowIso: boolean): IHeaderMenuItem[] {
  const { t } = useTranslation('side-menu')

  return useMemo(() => [
    { name: t('home'), url: '/' },
    { name: t('sport'), url: '/sport', partiallyActive: true },
    { name: t('services'), url: '/services', partiallyActive: true },
    { name: t('case study'), url: '/case-studies', partiallyActive: true },
    { name: t('career'), url: '/career', partiallyActive: true },
    { name: t('contact'), url: '/contact' },
    { name: t('technology radar'), url: '/technology-radar' },
    ...(shouldShowIso ? [{ name: t('iso certification'), url: '/iso' }] : []),
    { name: t('security'), url: '/security' },
    { name: t('privacy policy'), url: '/privacy-policy' },
  ], [t, shouldShowIso])
}

export default useHeaderMenuItems
